/**
 * Haalt de opmaak uit een stuk HTML, zodat er leesbare platte tekst overblijft.
 *
 * Notities worden als HTML bewaard; zonder dit staat er `<p>Joop was&nbsp;er</p>`
 * in een export of in een tooltip. Het resultaat is bedoeld om als TEKST te
 * tonen — er wordt nooit iets mee gerenderd, dus dit is geen sanitizer.
 * Voor HTML die wél de pagina op gaat is `src/utils/sanitizeHtml.js` de plek.
 *
 * ⚠️ Alleen voor inhoud die als HTML is OPGESLAGEN. Op platte tekst is deze
 * bewerking niet neutraal maar lossy, en stil: `<[^>]*>` vreet een stuk uit
 * 'budget <500> per maand', en `\s+ → ' '` trekt regels samen. Er staat dan
 * iets anders op het scherm dan in de database, zonder enig signaal.
 * Voor platte tekst is `plainTexts()` in helpers/notes/notePreview.js de plek.
 * AI-CONTEXT: See docs/pitfalls.md#dev-helper-lossy-on-input-it-claims-to-accept
 *
 * @param {string} html - Inhoud die als HTML is opgeslagen
 * @returns {string} Platte tekst zonder tags, entiteiten of dubbele witruimte
 */
const stripHtml = (html) => {
    if (!html) return ''

    return String(html)
        // Blokeindes en regelafbrekingen worden een spatie, anders plakken
        // woorden aan elkaar: 'regel1regel2'.
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/<\/(p|div|li|h[1-6])>/gi, ' ')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, ' ')
        .trim()
}

export default stripHtml
